'use client'
import clsx from 'clsx'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { loadOneTrustAtom } from '@/components/CookieConsent/OneTrustAtom'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import { preferenceButton, cookieInfoWrapper } from './CookieListBlock.css'

export function CookieListBlock() {
  const { t } = useTranslation('cookieConsent')
  const setLoadOneTrust = useSetAtom(loadOneTrustAtom)

  // Load OneTrust script to display the cookie list and handle user preferences
  useEffect(() => {
    setLoadOneTrust(true)
  }, [setLoadOneTrust])

  return (
    <GridLayout.Root>
      <GridLayout.Content width={{ _: '1', md: '2/3', xxl: '1/2' }} align={'center'}>
        <button id="ot-sdk-btn" className={clsx('ot-sdk-show-settings', preferenceButton)}>
          {t('COOKIE_CONSENT_SETTINGS_BUTTON')}
        </button>
        <div id="ot-sdk-cookie-policy" className={cookieInfoWrapper}></div>
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
